// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.slider-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}

.slider-block.slider-row {
    display: flex;
    flex-direction: row;
    gap: 25px;
    width: 100%;
}

.slider-block.slider-row .slider {
    flex: 2; /* Слайдер занимает 80% (4 части из 5) */
}

.slider-block.slider-row .slider-selector {
    flex: 1; /* Селектор также занимает равное пространство */
    display: flex;
    justify-content: flex-start; /* Убедитесь, что контент внутри селектора корректно позиционируется */
    align-items: center; /* Выравнивание по вертикали */
}

.slider {
    position: relative;
    width: 100%;
    height: 20px;
    cursor: pointer;
    user-select: none;
    border-radius: 16px;
}

.slider-track {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 7px;
    background: #c4c4c4;
    border-radius: 2px;
    z-index: 1;
    transition: 0.1s;
    transform: scaleY(0.5);
}

.slider-thumb {
    position: absolute;
    bottom: -3.5px;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background: #fff;
    border: 2px solid #005c32;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 2;
    transition: left 0.1s;
}

.min-max-row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #8b8b8b;
    font-size: 13px;
    font-weight: 500;
    padding-top: 20px;
}

@media screen and (max-width: 1000px) {
    .slider-block.slider-row .slider {
        flex: 3; /* Слайдер занимает 80% (4 части из 5) */
    }

    .slider-block.slider-row .slider-selector {
        flex: 2; /* Селектор также занимает равное пространство */
    }
}

@media screen and (max-width: 768px) {
    .slider-block.slider-row {
        flex-direction: column-reverse;
        gap: 0;
    }

    .slider-block.slider-row .slider {
        margin-top: 15px;
    }

    .slider-block.slider-row .slider .slider-thumb {
        top: 4px;
    }

    .slider-container.-mt-8 {
        margin-top: 0;
    }
}

.-mt-8 {
    margin-top: -16px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/slider/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,OAAO,EAAE,wCAAwC;AACrD;;AAEA;IACI,OAAO,EAAE,gDAAgD;IACzD,aAAa;IACb,2BAA2B,EAAE,sEAAsE;IACnG,mBAAmB,EAAE,8BAA8B;AACvD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,OAAO,EAAE,wCAAwC;IACrD;;IAEA;QACI,OAAO,EAAE,gDAAgD;IAC7D;AACJ;;AAEA;IACI;QACI,8BAA8B;QAC9B,MAAM;IACV;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".slider-container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n}\n\n.slider-block {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width: 100%;\n}\n\n.slider-block.slider-row {\n    display: flex;\n    flex-direction: row;\n    gap: 25px;\n    width: 100%;\n}\n\n.slider-block.slider-row .slider {\n    flex: 2; /* Слайдер занимает 80% (4 части из 5) */\n}\n\n.slider-block.slider-row .slider-selector {\n    flex: 1; /* Селектор также занимает равное пространство */\n    display: flex;\n    justify-content: flex-start; /* Убедитесь, что контент внутри селектора корректно позиционируется */\n    align-items: center; /* Выравнивание по вертикали */\n}\n\n.slider {\n    position: relative;\n    width: 100%;\n    height: 20px;\n    cursor: pointer;\n    user-select: none;\n    border-radius: 16px;\n}\n\n.slider-track {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    width: 100%;\n    height: 7px;\n    background: #c4c4c4;\n    border-radius: 2px;\n    z-index: 1;\n    transition: 0.1s;\n    transform: scaleY(0.5);\n}\n\n.slider-thumb {\n    position: absolute;\n    bottom: -3.5px;\n    transform: translate(-50%, -50%);\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 2px solid #005c32;\n    border-radius: 50%;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 2;\n    transition: left 0.1s;\n}\n\n.min-max-row {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    color: #8b8b8b;\n    font-size: 13px;\n    font-weight: 500;\n    padding-top: 20px;\n}\n\n@media screen and (max-width: 1000px) {\n    .slider-block.slider-row .slider {\n        flex: 3; /* Слайдер занимает 80% (4 части из 5) */\n    }\n\n    .slider-block.slider-row .slider-selector {\n        flex: 2; /* Селектор также занимает равное пространство */\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .slider-block.slider-row {\n        flex-direction: column-reverse;\n        gap: 0;\n    }\n\n    .slider-block.slider-row .slider {\n        margin-top: 15px;\n    }\n\n    .slider-block.slider-row .slider .slider-thumb {\n        top: 4px;\n    }\n\n    .slider-container.-mt-8 {\n        margin-top: 0;\n    }\n}\n\n.-mt-8 {\n    margin-top: -16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
